import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AppCtx = createContext(null);

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem("hg_cart") || "[]"); } catch { return []; }
  });
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("hg_token");
    if (token) {
      api.get("/auth/me").then(r => setUser(r.data)).catch(() => localStorage.removeItem("hg_token"));
    }
    setHydrated(true);
  }, []);

  useEffect(() => {
    if (hydrated) localStorage.setItem("hg_cart", JSON.stringify(cart));
  }, [cart, hydrated]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("hg_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const register = async (data) => {
    const r = await api.post("/auth/register", data);
    localStorage.setItem("hg_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const updateProfile = async (data) => {
    const r = await api.put("/auth/me", data);
    setUser(r.data);
    return r.data;
  };
  const logout = () => { localStorage.removeItem("hg_token"); setUser(null); };
  const setUserFromToken = (u) => setUser(u);

  const addToCart = (item) => {
    setCart(prev => {
      // configured hose items always add new; regular products merge by product_id
      if (item.configuration) return [...prev, { ...item, key: crypto.randomUUID() }];
      const idx = prev.findIndex(p => p.product_id === item.product_id && !p.configuration);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + item.quantity };
        return copy;
      }
      return [...prev, { ...item, key: crypto.randomUUID() }];
    });
  };
  const updateQty = (key, qty) => setCart(prev => prev.map(i => i.key === key ? { ...i, quantity: Math.max(1, qty) } : i));
  const removeItem = (key) => setCart(prev => prev.filter(i => i.key !== key));
  const clearCart = () => setCart([]);

  const cartCount = cart.reduce((s, i) => s + i.quantity, 0);
  const cartTotal = cart.reduce((s, i) => s + i.quantity * i.unit_price, 0);

  return (
    <AppCtx.Provider value={{ user, login, register, updateProfile, logout, setUserFromToken, cart, addToCart, updateQty, removeItem, clearCart, cartCount, cartTotal }}>
      {children}
    </AppCtx.Provider>
  );
};

export const useApp = () => useContext(AppCtx);
